// Drains a paginated list RPC. ryugu silently applies a default page size
// when the request carries no pagination (25 for ListPrograms, 50 for
// ListProgramTasks), so any "whole portfolio" view must page explicitly
// until a short page signals the end. maxPages is a runaway guard — when
// hit, `truncated: true` tells the caller to say so instead of presenting
// partial counts as authoritative.
export async function fetchAllPages(fetchPage, pageSize, maxPages) {
    const items = [];
    for(let page = 1; page <= maxPages; page++){
        const batch = await fetchPage(page);
        items.push(...batch);
        if (batch.length < pageSize) {
            return {
                items,
                truncated: false
            };
        }
    }
    return {
        items,
        truncated: true
    };
}
